import angular from 'angular';
import uiRouter from 'angular-ui-router';

import { transformODataResponse } from 'utilities/query';
import systemIngredientsComponent from './system-ingredients.component';
import systemIngredientsService from './system-ingredients.service';
import systemIngredientForm from './system-ingredient-form/system-ingredient-form.module';

export default
  angular.module('components.app.admin.system-ingredients', [
    uiRouter,
    systemIngredientForm
  ])
    .component('systemIngredients', systemIngredientsComponent)
    .service('SystemIngredientsService', systemIngredientsService)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('systemIngredients', {
          parent: 'admin',
          url: '/system-ingredients',
          component: 'systemIngredients',
          resolve: {
            flex: () => '100',
            layout: () => 'column',
            query: SystemIngredientsService => SystemIngredientsService.getDefaultQuery(),
            ingredients: (query, SystemIngredientsService) =>
              SystemIngredientsService.search(query).then(r => transformODataResponse(r))
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/admin/system-ingredients/system-ingredients.module.js